import React from "react";
import sortBy from "lodash/sortBy";
import * as colors from "../settings/colors";
import { Table, TableRow, TableCell } from "./Table";
import joinPath from "../utils/join-path";
import Link from "./Link";
import { TEXT_TERTIARY, DIVIDER } from "../settings/colors";

const columnSizing = "100px 1fr 1fr";

const TTY = Link.extend`
  font-family: monospace;
  font-weight: 600;
  color: ${props => props.color || colors.TEXT_SECONDARY};
`;

const FranchisesList = ({ franchises, match, ...otherProps }) => {
  const sortedFranchises = sortBy(franchises, "name");

  const renderFranchise = franchise => {
    const franchiseLink = joinPath(match.url, `/${franchise.id}`);
    const deactivatedColor = franchise.deactivated && TEXT_TERTIARY;

    return (
      <TableRow
        key={`franchise-${franchise.id}`}
        columns={columnSizing}
        style={{
          backgroundColor: franchise.deactivated ? DIVIDER : "transparent"
        }}
      >
        <TableCell>
          <TTY to={franchiseLink} color={deactivatedColor}>
            {franchise.assignedInHouseTty}
          </TTY>
        </TableCell>
        <TableCell>
          <Link to={franchiseLink} color={deactivatedColor}>
            <b>{franchise.name}</b>
          </Link>
        </TableCell>
        <TableCell>
          <Link to={franchiseLink} color={deactivatedColor}>
            {franchise.corporateName}
          </Link>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Table noSideBorders {...otherProps}>
      <TableRow header columns={columnSizing}>
        <TableCell>TTY</TableCell>
        <TableCell>Location Name</TableCell>
        <TableCell>Corporate Name</TableCell>
      </TableRow>
      {sortedFranchises.map(renderFranchise)}
    </Table>
  );
};

export default FranchisesList;



// WEBPACK FOOTER //
// ./src/components/FranchisesList.js